module.exports = __webpack_public_path__ + "img/selbsterfahrung_1280.5d24ce4e.png";